export enum ClassificationType {
    None = 0,
    Exclusive = 1,
    Excluded = 2
}